/**
 * Hokage (application_id 93) のテーマカラー。葉影 / emerald 系。
 * base = emerald-500 / 600、accent = green-400 のグラデーション。
 */
import { tailwindScales as tw } from "../tailwindColors";
import type { ThemePalette } from "../types";

export const HOKAGE_PALETTE: ThemePalette = {
  appId: "93",
  appName: "Hokage",
  cyan: tw.emerald,
  teal: tw.green,
  gradient: { from: tw.emerald[500], to: tw.green[400] },
  ink: { base: "#06231A", soft: "#3F6B57", mute: "#7D9C8E" },
  app: { bg: "#F2FAF5", card: "#FFFFFF" },
};
